import "./index.scss";

export const CheckoutMobileSteps = () => {
  return (
    <p className="mobile-steps">SIGN IN &gt; PAY & SUBMIT &gt; VIEW RECEIPT</p>
  );
};
